import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=a043128c&scoped=true"
import script from "./FooterInfo.vue?vue&type=script&lang=js"
export * from "./FooterInfo.vue?vue&type=script&lang=js"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&id=a043128c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a043128c",
  null
  
)

export default component.exports